import React from 'react';
import EmptyState from '../EmptyState';
import { COPY } from '../../../contracts/copyMap';

const NSFWRejection = ({ onRetry }) => (
  <EmptyState
    headline={COPY.REJECT_NSFW_HEADLINE}
    subtitle={COPY.REJECT_NSFW_SUBTITLE}
    ctaLabel={COPY.TRY_AGAIN_CTA}
    onCta={onRetry}
  />
);

export default NSFWRejection;
